import { useTranslation } from 'react-i18next';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';

import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { Button } from 'components/Form/Button/Button';
import { Translate } from 'components/Translate/Translate';

type OCRNudgeProps = {
  email: string;
};

export const OCRNudge = ({ email }: OCRNudgeProps) => {
  const { t } = useTranslation();
  const { isCopied, copyToClipboard } = useCopyToClipboard();

  return (
    <section>
      <h2 className="pt-8 pb-4 text-base font-bold text-gray-900">{t('dashboard:inbox.ocrNudge.title')}</h2>
      <div className="flex flex-col gap-4 rounded-2xl bg-gray-50 pt-4">
        <div className="flex items-center justify-between px-6">
          <span className="flex-1 text-sm text-gray-700">{email}</span>
          <Button
            variant="minimal"
            size="extra-small"
            LeftIcon={DocumentDuplicateIcon}
            onClick={() => copyToClipboard(email)}
            analyticsId="inbox-dashboard:copy-ocr-email"
          >
            {isCopied ? t('common:copied') : t('dashboard:inbox.ocrNudge.copy')}
          </Button>
        </div>
        <div className="border-t border-gray-200 px-6 py-3 text-xs text-gray-700">
          <Translate i18nKey="dashboard:inbox.ocrNudge.tip" />
        </div>
      </div>
    </section>
  );
};
